import createLucideIcon from '../createLucideIcon';

const ClipboardCheck = createLucideIcon('ClipboardCheck', [
  [
    'rect',
    {
      width: '8',
      height: '4',
      x: '8',
      y: '2',
      rx: '1',
      ry: '1',
      key: 'tgr4d6',
    },
  ],
  [
    'path',
    {
      d: 'M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2',
      key: '116196',
    },
  ],
  ['path', { d: 'm9 14 2 2 4-4', key: 'df797q' }],
]);

export default ClipboardCheck;
